<template>
  <!-- 货物品类类型 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          :data="menuTableData"
          style="width: 100%"
          row-key="typeId"
          border
          :height="leftHeight"
          default-expand-all
          @row-click="rowClickLeft"
          :tree-props="{
            children: 'childCategoryTypeList',
            hasChildren: 'hasChildren',
          }"
        >
          <el-table-column
            prop="typeName"
            label="品类类型"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click="menuadd(scope.row)"
                  >添加</span
                >

                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click="menumodify(scope.row)"
                  >修改</span
                >
                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click="delBtns(scope.row.typeId)"
                  >删除</span
                >
                <span
                  v-if="scope.row.isShow == 0"
                  class="tablebut"
                  @click="qiYong(scope.row.typeId)"
                  >启用</span
                >
                <span
                  v-if="scope.row.isShow == 1"
                  class="tablebut"
                  @click="jinYong(scope.row.typeId)"
                  >禁用</span
                >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems glo_bgcMainColor"
              @click="menuadd()"
              >新增类型
            </el-button>
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems glo_bgcMainColor"
              @click="addServe()"
              >新增品类
            </el-button>
            <el-button @click="qiYong_R()" class="glo_btnItems"
              >批量启用品类</el-button
            >
            <el-button @click="jinYong_R()" class="glo_btnItems"
              >批量禁用品类</el-button
            >
            <el-button @click="delMore" class="glo_btnItems"
              >批量删除品类</el-button
            >
          </div>

          <queryBtns
            :MoreConditions="MoreConditions"
            :showMoreBtns="false"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            :model="queryData"
            :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
            label-position="left"
          >
            <!-- <el-form-item class="queryItems" label="上级类型:">
              <el-input
                clearable
                placeholder="请输入"
                @keyup.enter.native="queryBtn_ok"
                v-model="queryData.parentName"
              ></el-input>
            </el-form-item> -->
            <el-form-item class="queryItems" label="上级类型:">
              <el-input
                clearable
                placeholder="请输入"
                @keyup.enter.native="queryBtn_ok"
                v-model="queryData.categoryName"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="类型名称:">
              <!-- <el-input
                clearable
                placeholder="请输入"
                @keyup.enter.native="queryBtn_ok"
                v-model="queryData.typeName"
              ></el-input> -->
              <el-select
                v-model="queryData.typeName"
                clearable
                placeholder="请输入关键词"
                filterable
                remote
                :loading="false"
                @change="changeTypeName1"
              >
                <el-option
                  v-for="(item, index) in parentList"
                  :key="index"
                  :label="item.typeName"
                  :value="item.typeName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="glo_Table" ref="tableWrapper">
          <el-table
            :height="tableHeigth"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            stripe
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column fixed="left" label="序号" type="index" width="60">
            </el-table-column>
            <el-table-column fixed="left" type="selection" width="60">
            </el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item.field == 'isShowShow'"
              >
                <template slot-scope="scope">
                  <div style="color: #f00" v-if="scope.row.isShow == '0'">
                    禁用
                  </div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              >
              </el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="220px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" @click.stop="editorServe(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="qiYong_R(scope.row.itemCategoryId)"
                    >启用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="jinYong_R(scope.row.itemCategoryId)"
                    >禁用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="DelServe_R(scope.row.itemCategoryId)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" min-width="220px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" @click.stop="menumodify(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="qiYong(scope.row.typeId)"
                    >启用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="jinYong(scope.row.typeId)"
                    >禁用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="delBtns(scope.row.typeId)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>

        <!-- 分页组件 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="total"
          :sizeList="sizeList"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <!--        自定义表头           -->
    <!-- <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable> -->

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormDataRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="menushowBOX"
          ref="dialogFormDataRef"
          :model="dialogFormData"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item
            class="dialogFormItems"
            prop="typeName"
            label="类型名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="dialogFormData.typeName"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="parentId"
            label="上级类型名称:"
          >
            <el-select
              v-model="dialogFormData.parentId"
              clearable
              placeholder="请输入关键词"
              filterable
              remote
              :loading="false"
              :remote-method="remoteMethod2"
            >
              <el-option
                v-for="item in parentList"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              placeholder="请输入"
              v-model="dialogFormData.sort"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isShow" label="启用状态:">
            <el-select
              clearable
              filterable
              v-model="dialogFormData.isShow"
              placeholder="请选择"
            >
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="remark" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogFormData.remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dislogFormTextarea"
            prop="conflictTypeId"
            label="冲突类型:"
          >
            <el-checkbox-group v-model="dialogFormData.conflictTypeId">
              <el-checkbox
                v-for="item in tableDataALL"
                :key="item.typeId"
                :label="item.typeId"
                >{{ item.typeName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 新建品类 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDiaR"
      @diaCancelBtn="handleCloseDiaR"
      @diaConfirmBtn="diaConfirmBtnR('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="itemCategoryName"
            label="品类名称:"
          >
            <el-input v-model="dialogForm.itemCategoryName"></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="channelItemcategoryTypeId"
            label="所属类型:"
          >
            <el-select
              v-model="dialogForm.channelItemcategoryTypeId"
              clearable
              placeholder="请输入关键词"
              filterable
              remote
              :loading="false"
              :remote-method="remoteMethod2"
              @change="changeTypeName"
            >
              <el-option
                v-for="(item, index) in parentList"
                :key="index"
                :label="item.typeName"
                :value="item.typeId + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input v-model="dialogForm.sort"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isShow" label="启用状态:">
            <el-select
              filterable
              clearable
              v-model="dialogForm.isShow"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isShowList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>


<script>
import paging from "@/components/pagings.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
// import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
export default {
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    myDialog,
    // sorttable,
  },
  data() {
    return {
      bumenTypeList: [], //部门类型
      dialogFormData: {
        conflictTypeId: [],
        isShow: "1",
        parentId: "",
        remark: "",
        sort: "1",
        typeName: "",
      },
      rules: {
        typeName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        isShow: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      menuTableData: [],
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        // parentName: "",
        // typeName: "",
        categoryName: "",
        typeName: "",
      },

      // ================
      pageStart: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      pageTotal: this.$COMMON.pageTotals, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "75vh",
      tableHeigth: "75vh",
      tabelHeadeTitle: [
        {
          name: "编号",
          field: "itemCategoryCode",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类名称",
          field: "itemCategoryName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "品类类型",
          field: "channelItemcategoryTypeName",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "排序",
          field: "sort",
          width: "100",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "isShowShow",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "comment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "creatorUserName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "编号",
        //   field: "number",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "120",
        // },
        // {
        //   name: "类型名称",
        //   field: "typeName",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "120",
        // },
        // {
        //   name: "上级类型",
        //   field: "parentName",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "120",
        // },
        // {
        //   name: "启用状态",
        //   field: "isShowShow",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "110",
        // },
        // {
        //   name: "排序",
        //   field: "sort",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "80",
        // },
        // {
        //   name: "冲突品类类型",
        //   field: "conflictTypeName",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "140",
        // },
        // {
        //   name: "备注",
        //   field: "remark",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "160",
        // },
        // {
        //   name: "新建时间",
        //   field: "createTime",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "160",
        // },
        // {
        //   name: "新建人",
        //   field: "createUserName",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "120",
        // },
        // {
        //   name: "修改时间",
        //   field: "updateTime",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "160",
        // },
        // {
        //   name: "修改人",
        //   field: "updateUserName",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   width: "120",
        // },
      ],
      tableData: [],
      tableDataALL: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      sortName: "货物品类类型模板", //排序名
      pageGroupName: "GoodsCategoryType", //页面标识
      selectTableData: [], //选中的数据

      deperIds: [],
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件
      dialogType: "add", //add==新建   edit==修改

      parentList: [], //上级
      conflictTypeIds: [], //原来的冲突品类类型

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        channelItemcategoryTypeId: "",
        comment: "",
        isShow: "1",
        itemCategoryName: "",
        sort: "1",
      },
      rulesForm: {
        isShow: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        itemCategoryName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowList: [
        {
          name: "启用",
          val: "1",
        },
        {
          name: "禁用",
          val: "0",
        },
      ],
      dialogTypeR: "add",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    if (this.originalTabelHeadeTitle.length == 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.myTableHeard = this.tabelHeadeTitle;
    // this.getGroupFindFieldSort(); //获取用户自定义表头

    this.endtime = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.sarttime = this.$TOOLS.getFlexDate(-3); //三天前
    this.times = [this.sarttime, this.endtime];

    // 左边列表
    this.departmentHierarchy();
    // 右边列表
    this.getData();
  },
  mounted() {
    const that = this;
    this.remoteMethod2();

    // this.getStatusValList("finance_in_record_v1.approve_status") || []; //审核状态列表
    // this.getdepartmentTypeList();
  },
  activated() {
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  watch: {},
  methods: {
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDiaR() {
      this.isShowDialog = false;
      this.dialogForm = {
        channelItemcategoryTypeId: "",
        comment: "",
        isShow: "1",
        itemCategoryName: "",
        sort: "1",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnR(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isShowDialog = false;
          let param = {
            channelItemcategoryTypeId:
              this.dialogForm.channelItemcategoryTypeId || "",
            comment: this.dialogForm.comment || "",
            isShow: this.dialogForm.isShow || "0",
            itemCategoryName: this.dialogForm.itemCategoryName || "",
            sort: this.dialogForm.sort || "1",
          };
          if (this.dialogTypeR == "add") {
            // 新建
            this.$API.wtl_addCategory(param).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.getData();
            });
          } else {
            // 编辑
            param.itemCategoryId = this.dialogForm.itemCategoryId || "";
            this.$API.wtl_udpateCategory(param).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.getData();
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    // 新建
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新建品类";
      this.dialogTypeR = "add";
      this.remoteMethod2();
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    // 编辑
    editorServe(row) {
      this.remoteMethod2();
      console.log(row);
      this.dialogForm = row;
      this.dialogForm.isShow = row.isShow + "";
      this.dialogForm.channelItemcategoryTypeId =
        row.channelItemcategoryTypeId + "";

      this.isShowDialog = true;
      this.dialogTitle = "编辑品类";
      this.dialogTypeR = "edit";
    },

    // 启用
    qiYong_R(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.itemCategoryId);
        });
      }
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          this.$API.wtl_startCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 禁用
    jinYong_R(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.itemCategoryId);
        });
      }
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          this.$API.wtl_stopCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },

    // 删除
    DelServe_R(id) {
      this.$confirm("是否删除所选数据?!", "提示:")
        .then((res) => {
          let ids = [id];
          let param = {
            itemCategoryIds: ids,
          };
          this.$API.wtl_delCategory(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },

    // =======================================

    // 查询条件
    changeTypeName1(e) {
      if (!e) {
        this.remoteMethod2();
      }
      this.queryBtn_ok();
    },

    changeTypeName(e) {
      if (!e) {
        this.remoteMethod2();
      }
    },

    // 批量启用
    qiYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.typeId);
          });
          this.$API.wtl_startCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 批量禁用
    jinYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.typeId);
          });
          this.$API.wtl_stopCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 启用
    qiYong(id) {
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.wtl_startCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 禁用
    jinYong(id) {
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.wtl_stopCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        // parentName: "",
        // typeName: "",
        categoryName: "",
        typeName: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.children || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].children || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },
    // 部门类型下拉列表
    getdepartmentTypeList() {
      this.$API.getdepartmentTypeList().then((res) => {
        if (res.data.status == "success") {
          let arrs = res.data.result || [];
          this.bumenTypeList = arrs;
        }
      });
    },

    // 左边列表
    departmentHierarchy() {
      this.$API.wtl_getLeftCategoryTypeList().then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          this.menuTableData = bmList;
          // this.menuTableData = this.diGuiGetMeun(bmList, "-1");
        }
      });
    },
    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.departmentName = item.departmentName;
          obj.children = [];
          temp = this.diGuiGetMeun(data, item.departmentId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      return tree;
    },
    // 弹窗上级地区远程搜索
    remoteMethod2(name, pname) {
      let param = {
        parentName: pname || "",
        typeName: name || "",
        pageStart: 1,
        pageTotal: 100,
      };
      this.$API.wtl_getCategoryTypeList(param).then((res) => {
        this.parentList = res.data.result.data || [];
        this.parentList.unshift({
          typeName: "无上级",
          typeId: "-1",
        });
        console.log("this.parentList", this.parentList);
      });
    },

    //菜单新建
    menuadd(row) {
      console.log(row);

      this.getChongtu();
      if (row) {
        this.dialogFormData.parentId = row.typeId;
        this.remoteMethod2(row.typeName);
      } else {
        this.remoteMethod2("");
      }
      this.$nextTick(() => {
        this.PopUpTitle = "新建品类类型";
        this.dialogType = "add";
        this.menushowBOX = true;
      });
    },
    //菜单修改
    menumodify(row) {
      this.PopUpTitle = "修改品类类型";
      this.dialogType = "edit";
      this.menushowBOX = true;
      this.getChongtu();
      this.remoteMethod2(row.parentName);
      this.getConflictCategoryTypeList(row.typeId);

      this.dialogFormData.parentId = row.parentId + "";
      this.dialogFormData.typeId = row.typeId + "";
      this.dialogFormData.number = row.number + "";
      this.dialogFormData.typeName = row.typeName || "";
      this.dialogFormData.sort = row.sort || "1";
      this.dialogFormData.isShow = row.isShow + "" || "0";
      this.dialogFormData.childCategoryTypeList =
        row.childCategoryTypeList || [];
    },
    // 获取冲突品类
    getConflictCategoryTypeList(typeId) {
      this.$API
        .wtl_getConflictCategoryTypeList({ typeId: typeId })
        .then((res) => {
          console.log("res conflictTypeId", res);
          let datas = res.data.result || [];
          let ids = [];
          let conflictTypeIds = [];
          datas.forEach((item) => {
            ids.push(item.typeId);
            let obj = {
              conflictTypeId: item.typeId,
              operationType: "UPDATE",
            };
            conflictTypeIds.push(obj);
          });
          this.dialogFormData.conflictTypeId = ids;
          this.conflictTypeIds = conflictTypeIds;
        });
    },
    // 删除
    delBtns(id) {
      this.$confirm("是否删除该类型?", "提示:")
        .then(() => {
          let ids = [id];
          let param = {
            typeIds: ids,
          };
          this.$API.wtl_delCategoryType(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 删除
    delMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否删除所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.typeId);
          });
          this.$API.wtl_delCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "删除成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.dialogFormData = {
        conflictTypeId: [],
        isShow: "1",
        parentId: "",
        remark: "",
        sort: "1",
        typeName: "",
      };
    },
    // //  关闭弹窗按钮事件(关闭按钮)
    // diaCancelBtn() {

    // },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            // 新建
            let param = {
              conflictTypeId: this.dialogFormData.conflictTypeId || [],
              isShow: this.dialogFormData.isShow || "0",
              parentId:
                this.dialogFormData.parentId == "-1"
                  ? ""
                  : this.dialogFormData.parentId,
              remark: this.dialogFormData.remark,
              sort: this.dialogFormData.sort || 1,
              typeName: this.dialogFormData.typeName,
            };
            this.$API.wtl_addCategoryType(param).then((res) => {
              this.menushowBOX = false;
              this.$message.success(res.data.message || "新建成功");
              this.getData();
              this.departmentHierarchy();
            });
          } else {
            // 修改
            let conflictTypeIds = JSON.parse(
              JSON.stringify(this.conflictTypeIds)
            );

            // 原来冲突类型的id
            let array1 = conflictTypeIds.map((item) => {
              return item.conflictTypeId;
            });

            // 新增的冲突
            let array1ADD = [];

            //修改的冲突id
            let ids = this.dialogFormData.conflictTypeId;

            for (var a = 0; a < conflictTypeIds.length; a++) {
              if (ids.indexOf(conflictTypeIds[a].conflictTypeId) == -1) {
                conflictTypeIds[a].operationType = "DEL";
              }
            }
            for (var b = 0; b < ids.length; b++) {
              if (array1.indexOf(ids[b]) == -1) {
                let obj = {
                  conflictTypeId: ids[b],
                  operationType: "ADD",
                };
                array1ADD.push(obj);
              }
            }
            conflictTypeIds = conflictTypeIds.concat(array1ADD);

            let param = {
              isShow: this.dialogFormData.isShow || "0",
              parentId:
                this.dialogFormData.parentId == "-1"
                  ? ""
                  : this.dialogFormData.parentId,
              remark: this.dialogFormData.remark,
              sort: this.dialogFormData.sort || 1,
              typeName: this.dialogFormData.typeName,
              typeId: this.dialogFormData.typeId,
              conflictTypeIds: conflictTypeIds || [],
            };
            this.$API.wtl_udpateCategoryType(param).then((res) => {
              this.menushowBOX = false;
              this.$message.success(res.data.message || "修改成功");
              this.getData();
              this.departmentHierarchy();
            });
          }
        }
      });
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;

        this.leftHeight = windonHeight - 85;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    rowClickLeft(tree) {
      console.log(tree, "tree");
      // this.queryData.categoryName = tree.categoryName;
      this.queryData.typeName = tree.typeName;
      this.getData();
    },

    // 获取数据
    getData() {
      // let param = {
      //   parentName: this.queryData.parentName,
      //   typeName: this.queryData.typeName,
      //   pageStart: this.pageStart,
      //   pageTotal: this.pageTotal,
      // };
      // this.$API.wtl_getCategoryTypeList(param).then((res) => {
      //   if (res.data.status == "success") {
      //     this.className = res.data.result.className || "";
      //     this.tableData = res.data.result.data || [];
      //     this.total = res.data.result.pageCount || 0;
      //     this.fetTableHeight();
      //   }
      // });
      let that = this;
      if (this.queryData.typeName == "无上级") {
        this.queryData.typeName = "";
      }
      let param = {
        categoryName: this.queryData.categoryName,
        typeName: this.queryData.typeName,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getCategoryList(param).then((res) => {
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        that.$nextTick(() => {
          that.fetTableHeight();
        });
      });
    },
    // 获取所属品类类型
    getChongtu() {
      let param = {
        pageStart: 1,
        pageTotal: 200,
      };
      this.$API.wtl_getCategoryTypeList(param).then((res) => {
        this.tableDataALL = res.data.result.data || [];
      });
    },
    // 查询按钮
    queryBtn_ok() {
      this.pageStart = 1;
      this.getData();
    },
    // 重置按钮
    queryBtn_cz() {
      this.queryData = {
        storageName: "",
      };
    },

    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              that.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            that.myTableHeard = that.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < that.myTableHeard.length; i++) {
            if (that.myTableHeard[i].isTotal) {
              totalArr.push(that.myTableHeard[i].field);
            }
          }
          that.totalArr = totalArr;
        });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },

    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk() {
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //综合查询接口路径
        },
        {
          key: "groupName",
          val: this.pageGroupName,
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = this.$TOOLS.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang='less'>
.box {
  width: 100%;
  display: flex;
}
.boxleft {
  // width: 40%;
  width: 370px;
  //   min-width: 390px;
  //   height: 88vh;
  overflow: auto;
  margin-right: 30px;
  // border: 1px solid #d7d7d7;
}
.boxright {
  // width: 70%;
  // flex: 1;
  // height: 500px;
  width: calc(100% - 430px);
}
.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}
</style>